import { useQuery } from '@apollo/client';

import { OverviewCardPeriod } from 'components/OverviewChartCard';
import {
  ZoneOverviewIbcVolumeDocument,
  ZoneOverviewIbcVolumeQueryResult,
} from 'graphql/v2/ZonesPage/ZonePage/__generated__/ZoneOverviewIbcVolume.query.generated';
import {
  ZoneOverviewIbcVolumeFromIbcTxsDocument,
  ZoneOverviewIbcVolumeFromIbcTxsQueryResult,
} from 'graphql/v2/ZonesPage/ZonePage/__generated__/ZoneOverviewIbcVolumeFromIbcTxs.query.generated';
import { ArraysMapping, mergeChartArraysIntoOne } from 'utils/mergeChartArraysIntoOne';

import { IbcVolumeChart, ZoneOverviewIbcVolumeCardData } from './ZoneOverviewIbcVolume.types';
import { useZoneOverviewOptions } from '../ZoneOverview/hooks/useZoneOverviewOptions';

type IbcVolumeCardApi = ZoneOverviewIbcVolumeQueryResult['ibcVolumeCardData'];
type IbcVolumeChartApi = NonNullable<IbcVolumeCardApi>['ibcVolumeInChart'][number];
type IbcVolumeInChartApi = NonNullable<IbcVolumeCardApi>['ibcVolumeInChart'][number];
type IbcVolumeOutChartApi = NonNullable<IbcVolumeCardApi>['ibcVolumeOutChart'][number];

const chartsMapping: ArraysMapping<
  IbcVolumeCardApi,
  IbcVolumeChartApi & IbcVolumeInChartApi & IbcVolumeOutChartApi,
  IbcVolumeChart
> = {
  ibcVolumeChart: {
    from: 'volume',
    to: 'total',
  },
  ibcVolumeInChart: {
    from: 'volumeIn',
    to: 'ibcIn',
  },
  ibcVolumeOutChart: {
    from: 'volumeOut',
    to: 'ibcOut',
  },
};

export function useZoneOverviewIbcVolumeCard(period: OverviewCardPeriod): {
  data: ZoneOverviewIbcVolumeCardData | undefined;
  loading: boolean;
} {
  const options = useZoneOverviewOptions(period);

  const { data: ibcVolumeData, loading: isDataLoading } =
    useQuery<ZoneOverviewIbcVolumeQueryResult>(ZoneOverviewIbcVolumeDocument, options);
  const { data, loading } = useQuery<ZoneOverviewIbcVolumeFromIbcTxsQueryResult>(
    ZoneOverviewIbcVolumeFromIbcTxsDocument,
    options
  );

  console.log(data);

  return {
    data: {
      totalIbc:
        data?.ibcVolumeCardData?.ibcVolumeIn?.sum?.volumeIn +
        data?.ibcVolumeCardData?.ibcVolumeOut?.sum?.volumeOut,
      totalIbcIn: data?.ibcVolumeCardData?.ibcVolumeIn?.sum?.volumeIn,
      totalIbcOut: data?.ibcVolumeCardData?.ibcVolumeOut?.sum?.volumeOut,
      chart: mergeChartArraysIntoOne(ibcVolumeData?.ibcVolumeCardData, chartsMapping),
    },
    loading,
  };
}
